<template>
    <v-container fluid>
        <div style="margin-bottom: 10px">
            <v-card>
                <v-card-text>
                    <v-row v-if="report">
                        <v-col md="1" class="align-self-center">
                            <v-btn
                                class="mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                :to="{ name: 'report-list' }"
                            >
                                <v-icon dark> mdi-arrow-left </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="6" class="align-self-center">
                            <h4>{{ report.name }}<br /></h4>
                            {{ report.created_at }}
                        </v-col>
                        <v-col md="2" class="align-self-center">
                            {{ report.type }}
                        </v-col>
                        <v-col md="3" class="text-right">
                            <v-btn
                                @click="saveConfig()"
                                depressed
                                color="success"
                            >
                                Salva
                                <v-icon right> mdi-floppy </v-icon>
                            </v-btn>
                            <v-btn
                                @click="removeReport(report.id)"
                                depressed
                                color="error"
                            >
                                Elimina
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col md="1" class="align-self-center">
                            <v-btn
                                class="mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                :to="{ name: 'report-list' }"
                            >
                                <v-icon dark> mdi-arrow-left </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="6"> &nbsp; </v-col>
                        <v-col md="3">
                            <v-text-field
                                v-model="report_name"
                                label="Nome Report *"
                            ></v-text-field>
                        </v-col>
                        <v-col md="2" class="align-self-center text-right">
                            <v-btn
                                color="primary"
                                @click="saveConfig()"
                                :disabled="loading || !report_name"
                            >
                                Salva
                                <v-icon right> mdi-floppy </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </div>
        <div class="text-center" v-if="loading">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>
        <div v-if="report_type == 'report1'">
            <div v-for="product in prodList" class="table-content">
                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                            <tr class="first-tr">
                                <td rowspan="4" width="8%">
                                    <router-link
                                        target="_blank"
                                        :to="{
                                            name: 'product',
                                            query: { id: product.ar_codart },
                                        }"
                                    >
                                        <v-img
                                            :src="imagePath(product.ar_codart)"
                                            width="80"
                                            height="80"
                                        ></v-img>
                                    </router-link>
                                </td>
                                <td width="14%">
                                    COD ART: <b>{{ product.ar_codart }}</b>
                                </td>
                                <td>
                                    DESC: <b>{{ product.ar_descr }}</b>
                                </td>
                                <td width="17%">
                                    COD ART FORN:
                                    <b>{{ product.xx_codarfo }}</b>
                                </td>
                                <td width="22%">
                                    FORNITORE: <b>{{ product.ar_codforn }}</b> -
                                    <b>{{ product.an_descr1 }}</b>
                                </td>
                                <td width="14%" class="last-col">
                                    BARCODE: <b>{{ product.bc_code }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    ULTIMO ACQUISTO:
                                    <b>{{ product.ultimo_acquisto_qty }}</b>
                                </td>
                                <td>
                                    STOCK: <b>{{ product.xx_dissede }}</b>
                                </td>
                                <td>
                                    INNER: <b>{{ product.ar_inner }}</b> - CT:
                                    <b>{{ product.ar_cartonaggio }}</b>
                                </td>
                                <td>
                                    CBM: <b>{{ product.ar_volume }}</b>
                                </td>
                                <td class="last-col">
                                    <b>H:</b> {{ product.ar_misura1 }}
                                    <b>L:</b> {{ product.ar_misura2
                                    }}<b> P:</b> {{ product.ar_misura3 }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    ULTIMA DATA ACQ:
                                    <b>{{ product.ultimo_acquisto_data }}</b>
                                </td>
                                <td>
                                    LIST 5:
                                    <b
                                        >&euro;
                                        {{ product.lc_prezzo5 | formatEuro }}</b
                                    >
                                </td>
                                <td>
                                    LIST 6:
                                    <b
                                        >&euro;
                                        {{ product.lc_prezzo6 | formatEuro }}</b
                                    >
                                </td>
                                <td>
                                    LIST 2:
                                    <b
                                        >&euro;
                                        {{ product.lc_prezzo2 | formatEuro }}</b
                                    >
                                </td>
                                <td class="last-col">
                                    LIST 3:
                                    <b
                                        >&euro;
                                        {{
                                            calcoloScontoFrancising(product)
                                                | formatEuro
                                        }}</b
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    TOT CARICO
                                    <b v-if="product.tot_carico"
                                        >&euro;
                                        {{ product.tot_carico | formatEuro }}</b
                                    >
                                </td>
                                <td>
                                    TOT VEND
                                    <b v-if="product.tot_vendite"
                                        >&euro;
                                        {{
                                            product.tot_vendite | formatEuro
                                        }}</b
                                    >
                                </td>
                                <td>
                                    TOT GIAC
                                    <b v-if="product.tot_giacenze"
                                        >&euro;
                                        {{
                                            product.tot_giacenze | formatEuro
                                        }}</b
                                    >
                                </td>
                                <td colspan="2" class="last-col">
                                    VEND / ACQ =
                                    <b v-if="product.tot_carico">{{
                                        Math.round(
                                            (product.tot_vendite /
                                                product.tot_carico) *
                                                100
                                        )
                                    }}</b
                                    >%
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>
        </div>
        <div v-else-if="report_type == 'report2'">
            <div v-for="product in prodList" class="table-content">
                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                            <tr class="first-tr">
                                <td rowspan="4" width="8%">
                                    <router-link
                                        target="_blank"
                                        :to="{
                                            name: 'product',
                                            query: { id: product.ar_codart },
                                        }"
                                    >
                                        <v-img
                                            :src="imagePath(product.ar_codart)"
                                            width="80"
                                            height="80"
                                        ></v-img>
                                    </router-link>
                                </td>
                                <td width="14%">
                                    ITEM N: <b>{{ product.ar_codart }}</b>
                                </td>
                                <td>
                                    ITEM DESC: <b>{{ product.ar_descr }}</b>
                                </td>
                                <td width="17%">
                                    SUPPLIER ITEM:
                                    <b>{{ product.xx_codarfo }}</b>
                                </td>
                                <td width="22%">
                                    SUPPLIER: <b>{{ product.ar_codforn }}</b> -
                                    <b>{{ product.an_descr1 }}</b>
                                </td>
                                <td width="14%" class="last-col">
                                    BARCODE: <b>{{ product.bc_code }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    CARTON: <b>{{ product.ar_cartonaggio }}</b>
                                </td>
                                <td>
                                    STOCK: <b>{{ product.xx_dissede }}</b>
                                </td>
                                <td>
                                    INNER: <b>{{ product.ar_inner }}</b> - CT:
                                    <b>{{ product.ar_cartonaggio }}</b>
                                </td>
                                <td>
                                    CBM: <b>{{ product.ar_volume }}</b>
                                </td>
                                <td class="last-col">
                                    <b>H:</b> {{ product.ar_misura1 }}
                                    <b>L:</b> {{ product.ar_misura2
                                    }}<b> P:</b> {{ product.ar_misura3 }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    LIST 5:
                                    <b
                                        >&euro;
                                        {{ product.lc_prezzo5 | formatEuro }}</b
                                    >
                                </td>
                                <td>
                                    LIST 6:
                                    <b
                                        >&euro;
                                        {{ product.lc_prezzo6 | formatEuro }}</b
                                    >
                                </td>
                                <td>
                                    <v-text-field
                                        type="number"
                                        label="ORDER QTY"
                                        v-model="product.order_qty"
                                    ></v-text-field>
                                </td>
                                <td class="last-col" colspan="2">
                                    <v-text-field
                                        v-model="product.desc_it"
                                        label="ITALIAN DESC"
                                    ></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <td class="last-col" colspan="5">
                                    <v-textarea
                                        :rows="2"
                                        v-model="product.note"
                                        label="NOTE"
                                    ></v-textarea>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>
        </div>
    </v-container>
</template>
<style lang="scss" scoped>
.table-content {
    margin-bottom: 10px;

    &:nth-child(even) {
        .v-data-table::v-deep > .v-data-table__wrapper > table {
            background-color: #f1f1f1;
        }
    }
}

.v-data-table::v-deep > .v-data-table__wrapper > table {
    th,
    tr.first-tr > td {
        border-top: 1px solid black !important;
    }

    td {
        border-left: 1px solid black;
        border-bottom: 1px solid black !important;

        &.last-col {
            border-right: 1px solid black !important;
        }
    }
}
</style>
<script>
import ProductImage from "../../components/ProductImage.vue";
import requests from "../../requests";
export default {
    name: "report1-page",
    components: { ProductImage },
    data: () => {
        return {
            prodList: [],
            report: null,
            report_name: null,
            report_type: null,
            loading: false,
        };
    },
    mounted() {
        console.log("Report 1 Mounted.");
        this.report_type = this.$route.params.report;
        if (_.isUndefined(this.$route.params.id)) {
            this.getProducts();
        } else {
            this.getProducts(this.$route.params.id);
        }
    },
    methods: {
        getProducts(id = null) {
            this.loading = true;
            requests.getReportListData(id).then((res) => {
                this.prodList = res.data.list;
                this.report = res.data.report;
                this.loading = false;
            });
        },
        imagePath(prodId) {
            if (!this.error) {
                let normId = prodId.replace("/", "_") + ".jpg";
                return "/images/catalog/lower/" + normId;
            } else {
                return "no_image.jpg";
            }
        },
        saveConfig() {
            let id = null;
            let reportName = this.report_name;
            let reportType = this.report_type;

            if (!_.isUndefined(this.report) && !_.isNull(this.report)) {
                id = _.isUndefined(this.report.id) ? null : this.report.id;
                reportName = this.report.name;
                reportType = this.report.type;
            }
            if (!_.isUndefined(this.report) && _.isNull(this.report) && _.isEmpty(reportName)) {
                window.alert("Inserisci il nome del report");
                return false;
            }

            requests
                .saveReport(reportName, reportType, id, this.prodList)
                .then((res) => {
                    this.$router.push({
                        name: "report1",
                        params: { id: res.data.id, report: this.report_type },
                    });
                    window.location.reload();
                });
        },
        removeReport(id) {
            if (!window.confirm("Vuoi eliminare questo report?")) return false;
            requests.deleteReportList(id).then((res) => {
                if (res.data.result) {
                    this.$router.push({ name: "report-list" });
                }
            });
        },
        calcoloScontoFrancising(product) {
            let prezzo = product.lc_prezzo2;
            let sconto1 = product.so_sconto1l3;
            let sconto2 = product.so_sconto2l3;
            let ris = prezzo - (prezzo * sconto1) / 100;
            return ris - (ris * sconto2) / 100;
        },
    },
    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    },
};
</script>
